import React from 'react';
import '../styles/Skeleton.scss';

const SkeletonComponent: React.FC = () => {
  return (
    <div className="merchant-item skeleton">
      <div className="merchant-image-wrapper">
        <div className="merchant-hero skeleton-box">
          <div className="overlay" />
        </div>
      </div>
      <p className="merchant-name skeleton-text"></p>
    </div>
  );
};

export default SkeletonComponent;